export const mockProjects = [
  {
    id: 1,
    title: 'SPACES',
    category: 'Jeu',
    badgeColor: 'bg-[#FF6B35]',
    description: 'Explore l\'espace infini dans ce jeu spatial captivant !',
    scratchId: '1202670707'
  },
  {
    id: 2,
    title: 'FOOTx2',
    category: 'Jeu',
    badgeColor: 'bg-[#FF6B35]',
    description: 'Un jeu de foot palpitant avec action doublée !',
    scratchId: '1202416101'
  },
  {
    id: 3,
    title: 'JeuxPiques',
    category: 'Jeu',
    badgeColor: 'bg-[#FF6B35]',
    description: 'Évite les piques et relève le défi dans ce jeu d\'adresse !',
    scratchId: '1203220485'
  }
];

export const mockContactSubmissions = [];